import { type FC } from 'react'
import { type IInboxTreeCombine, type INodeModel } from 'entities/Inbox'
import { GroupInbox } from 'entities/Inbox/model/GroupInbox'
import { Inbox } from 'entities/Inbox/model/Inbox'
import { SmartView } from 'entities/SmartViews/model/SmartView'
import {
  MenuCardInbox,
  MenuCardInboxGroup,
  MenuCardSmartViewInbox,
} from 'pages/conversations/ui/ConversationMenu/ui/ConversationMenuInboxes/MenuCard'

type IMenuCardPreviewTreeProps = {
  node: INodeModel<IInboxTreeCombine>
  onToggle?: () => void
  isOpen?: boolean
}

export const MenuCardPreviewTree: FC<IMenuCardPreviewTreeProps> = ({
  node,
  onToggle = () => {},
  isOpen = false,
}) => {
  const { data, droppable } = node
  const inbox = data

  if (!inbox) return null

  if (inbox instanceof GroupInbox) {
    return (
      <MenuCardInboxGroup item={inbox} onToggle={onToggle} isOpen={isOpen} droppable={droppable} />
    )
  }

  if (inbox instanceof Inbox) {
    return <MenuCardInbox item={inbox} />
  }

  if (inbox instanceof SmartView) {
    return <MenuCardSmartViewInbox item={inbox} />
  }

  return null
}
